// addressId
const addressId = 'addressId'

export let isAddressId = {
    fetch(){
        return localStorage.getItem('addressId') || ''
    },
    remove(){
        return localStorage.removeItem('addressId') || true
    },
    save(val){
        localStorage.setItem(addressId,val)
    }
}


// WEBPACK FOOTER //
// ./src/utils/addressId.js